const FilterNav = {

	elements: {},

	activeFilterClass: 'filter--expanded',

	toggleMenu(element)
	{
		element.classList.toggle(this.activeFilterClass);
		element.closest('.js-filter-overlay').classList.toggle('is-expanded');
	},

	cacheDom()
	{
		this.elements.filterTriggers = document.querySelectorAll('.js-filter-trigger');
	},

	bind()
	{
		if( this.elements.filterTriggers )
		{
			Array.prototype.forEach.call(this.elements.filterTriggers, (element) => {
				element.addEventListener('click', () => { this.toggleMenu(element.parentNode) } );
			});

		}
	},

	init()
	{
		this.cacheDom();
		this.bind();
	}
};

export default FilterNav;